import React, { FC } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import './feedback-tab.less';
import { SimpleFeedbackFormAnswerDto } from 'stores/events/feedback-forms-store';
import { CountryFlag } from 'widgets/bussiness/country-flag';

interface tailwindFeedbackTableProps extends WithTranslation {
  readOnly?: boolean;
  forms: SimpleFeedbackFormAnswerDto[];
  handleOnRemoveFeedBack: (feedbackFormAnswerClicked: SimpleFeedbackFormAnswerDto) => void;
  templateId: string;
  onOpenEmployeeFeedBackForm: (form: SimpleFeedbackFormAnswerDto) => void;
  isEventClosed?: boolean;
  canRemoveFeedback?: boolean;
}

const TailwindFeedbackTable: FC<tailwindFeedbackTableProps> = ({
  forms,
  handleOnRemoveFeedBack,
  onOpenEmployeeFeedBackForm,
  isEventClosed,
  canRemoveFeedback
}) => {
  return (
    <div onClick={() => {}} className={`w-full bg-white shadow p-4 mt-4 overflow-y-auto transition-all duration-300 max-h-[300px]`}>
      <div className="mb-3"></div>
      {(forms || []).map((form, idx) => {
        const { user, id, userId, answered } = form;
        return (
          <div className="border-l-4 p-3 mb-2 cursor-pointer shadow-md">
            <div className="flex justify-between items-center">
              <div className="flex-1">
                <div className="flex items-center gap-2">
                  <h4 className="text-black-600 font-semibold">{`${user.firstName}  ${user.lastName}`}</h4>
                </div>
                <p className="text-xs text-gray-500">{user.userName}</p>
                <p className="text-sm">{user.sfPosition}</p>
                <p className="text-sm">
                  {user.location ? (
                    <>
                      <CountryFlag countryName={user.location.countryName} />
                      {` ${user.location.location}`}
                    </>
                  ) : (
                    '-'
                  )}
                </p>
              </div>

              <div className="flex items-center gap-2">
                <div hidden={!answered} key={`${idx}_${id}_${userId}_eye`} onClick={() => answered && onOpenEmployeeFeedBackForm(form)}>
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white cursor-pointer"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path stroke="currentColor" strokeWidth="2" d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                    <path stroke="currentColor" strokeWidth="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                </div>

                <div
                  hidden={isEventClosed || !canRemoveFeedback}
                  key={`${idx}_${id}_${userId}_remove`}
                  onClick={() => handleOnRemoveFeedBack(form)}
                >
                  <svg
                    className="w-6 h-6 text-gray-800 dark:text-white cursor-pointer"
                    aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke="currentColor"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M3 15v3c0 .5523.44772 1 1 1h16c.5523 0 1-.4477 1-1v-3M3 15V6c0-.55228.44772-1 1-1h16c.5523 0 1 .44772 1 1v9M3 15h18M8 15v4m4-4v4m4-4v4m-5.5061-7.4939L12 10m0 0 1.5061-1.50614M12 10l1.5061 1.5061M12 10l-1.5061-1.50614"
                    />
                  </svg>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default withTranslation()(TailwindFeedbackTable);
